<script>
// 加载中
import InnerLoading from "@/components/spinner/spinner.vue";
// 动态表单模版
import Temp from '@/components/technician/temp/index'
import {
  processAllmytask,
  processNewdetails,
  // processRemove,
  processTaskHistorical
} from "@/lib/request";
export default {
  name:'myApply',
  data(){
    return{
      innerLoading:false,
      // 动态表单模版
      returnObj:{},
      formDefine:{},
      siteItem:{},
      flowNameObj:{},
      formFields:[],
      historyList:[],
      flagTemp:false,
      submitText:'',
      activeTab:1,

      // 列表数据
      page1:0,//当前页
      size1:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      inList:[],
    }
  },
  components: {
    InnerLoading,
    Temp,
  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function() {
      this.getSiteApplyList();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        size:this.size1,//每页数量
        page:this.page1,//当前页码
        classify:this.activeTab,
        // openId:this.user_openid,//
        // orderByColumn:'createTime',
        // isAsc:'asc',
        // state:this.activeTab//积分类型
      };
    },
  },
  methods:{
    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },
    showModal(type){
      console.log(type)
    },

    // 流程表单提交接口
    getTempReturn(data){
      console.log(data)
      this.flagTemp = false;
      this.submitText = '';
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.getSiteApplyList();
    },
    showApplicationDetail(item,type){
      if(item.processInstanceId){
        this.innerLoading = true;
        this.submitText = '';
        this.formFields = [];
        this.returnObj = {};
        this.formDefine = {};
        this.historyObjectData(item.processInstanceId,type);
      }
    },
    // showPage(router){
    //   console.log(router)
    //   this.$router.push({path:router})
    // },
    // 流程里面做完的流程历史数据
    historyObjectData(processInstanceId,type){
      processTaskHistorical({
        processInstanceId:processInstanceId,
        handler:false
      }).then((res)=> {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.data.historicActivityInstances&&res.data.data.historicActivityInstances.length>0){
                res.data.data.historicActivityInstances.map((v)=>{
                  if(v.formInfo.fields){
                    v.formInfo.fields.map((i)=>{
                      if(i.params.customDesign.type==='fileupload'){
                        i.files =  i.value?i.value.split(','):[];
                      }else if(i.params.customDesign.type==='rate'){
                        i.value = i.value?parseInt(i.value)/2:0;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
                if(type==='info'){
                  this.flagTemp = true;
                }
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            if(type==='info') {
              this.innerLoading = false;
            }
          }
        }
      });
    },
    getActiveItemInfo(item){
      if(item.taskId){
        this.innerLoading = true;
        processNewdetails({
          taskId:item.taskId,
          processInstanceId:item.processInstanceId
        }).then((res)=> {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                if(res.data.data&&res.data.data.variables.processInstanceId){
                  this.historyObjectData(res.data.data.variables.processInstanceId);
                }else{
                  this.historyList = [];
                }
                this.siteItem = {
                  branchId: item.variables.siteid,
                  processDefinitionName: '一般巡检',//item.processInstanceName:"代销者巡检"
                };
                this.returnObj = res.data.data;
                this.taskId = item.taskId;
                let formDefine = JSON.parse(res.data.data.formDefine);
                if(formDefine){
                  this.formDefine = formDefine;
                  if(formDefine.fields.length>0){
                    formDefine.fields.map((v)=>{
                      v.id_name = '';
                      v.showItem = true;
                      if(v.id.indexOf('Name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('phone')!==-1){
                        v.id_name = 'phone'
                      }else if(v.id.indexOf('identity')!==-1){
                        v.id_name = 'identity'
                      }
                      if(v.params.customDesign){
                        if(v.params.customDesign.type==='fileupload'){
                          v.files = [];
                        }else if(v.params.customDesign.type==='rate'){
                          v.socre = 0;
                          v.scoreValue = 0;
                          v.scoreValueFlag = true;
                        } else if (v.params.customDesign.type === 'date') {
                          v.dates = '';
                          v.dateValue = '';
                          v.dateValueFlag = true;
                        } else if (v.params.customDesign.type === 'select') {
                          // 复选框
                          if(v.params.customDesign.multiple){
                            v.checkList = []
                          }
                        }
                      }
                    });
                    this.submitText = '提交';
                    // this.flowNameObj = item;
                    this.formFields = formDefine.fields;
                    this.flagTemp = true;
                  }
                }
              }else{
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      }
    },
    getSiteApplyList(){
      /*{
        size:3,//每页数量
        page:0,//当前页码
        classify:0,//（0:全部,1:进行中,2：已完结）
      }*/
      this.loading1 = true;
      this.finished1 = false;
      if(this.searchParams.page===0){
        this.inList=[]
      }
      processAllmytask(this.searchParams).then((res)=>{
        if(res){
          if(res.data){
            this.loading1 = false;
            if(res.data.code===200){
              let resData = res.data.data.list;
              if(resData&&resData.length>0){
                resData.map((v)=>{
                  if(v.processInstanceName){
                    if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>1){
                      if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>0){
                        v.arr_name = v.processInstanceName.split('-')[1];
                      }
                    }else{
                      v.arr_name = v.processInstanceName;
                    }
                  }
                });
                this.totals1 = res.data.data.total;
                this.totalPages1 = Math.ceil(res.data.data.total / this.size1);
                if (resData.length === 0) {
                  this.finished1 = true;
                  this.inList = [];
                  return false;
                } else {
                  if (this.page1 > 1) {
                    this.inList = this.inList.concat(resData);
                  } else {
                    this.inList = resData;
                  }
                  // 总条数和每页条数
                  if (this.totals1 < this.size1) {
                    this.finished1 = true;
                    return;
                  }
                  // 当前页和总页数
                  if (this.page1 === this.totalPages1) {
                    this.finished1 = true;
                    return false;
                  }
                }
              }else{
                if (resData.length === 0) {
                  this.finished1 = true;
                  this.inList = [];
                  return false;
                }
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // //流程创建后未提交表单的数据，可删除
    // getApiDel(item) {
    //   processRemove({
    //     processInstanceId: item.processInstanceId
    //   }).then((res) => {
    //     if (res) {
    //       if (res.data) {
    //         if (res.data.code === 200) {
    //           this.page1 = 0;
    //           this.getSiteApplyList();
    //         } else {
    //           this.$toast.fail(res.data.msg);
    //         }
    //       }
    //     }
    //   });
    // },
  },
  created(){
    // this.getSiteApplyList();
  }
}
</script>

<template>
  <!-- 我的申请页面 -->
  <div id="applicationsPage" class="">
    <!--    加载中-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    动态表单模版-->
    <Temp v-model="flagTemp" content="close" :variablesObj="{}" :submitText="submitText" :flowNameObj="flowNameObj" :historyList="historyList" :siteIdObj="siteItem" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
    <!--    html    -->
    <div class="content">
      <div class="tabs">
        <van-tabs v-model="activeTab" animated swipeable sticky>
          <van-tab title="待领取" name="3"></van-tab>
          <van-tab title="处理中" name="1"></van-tab>
          <van-tab title="已完成" name="2"></van-tab>
        </van-tabs>
      </div>

      <div id="processingApps" class="tab-content">
        <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">
          <div class="card" v-for="(item,index) in inList" :key="index">
            <div class="card-title">
              {{item.arr_name}}
              <span class="status-tag tag-progress" v-if="item.type==='1'">处理中</span>
              <span class="status-tag tag-complete" v-else-if="item.type==='2'">已完成</span>
              <span class="status-tag tag-noStars" v-else-if="item.type==='3'">待领取</span>
            </div>
            <div class="card-info" v-if="item.variables&&item.variables.siteid">
              <div class="info-label">申请网点</div>
              <div class="info-value">{{ item.variables.siteid }}</div>
            </div>
            <div class="card-info" v-show="item.name">
              <div class="info-label">流程进度</div>
              <div class="info-value">{{ item.name }}</div>
            </div>

            <div class="card-info" v-show="item.variables&&item.variables.name">
              <div class="info-label">姓名</div>
              <div class="info-value">{{ item.variables.name  }}</div>
            </div>
            <div class="card-info" v-show="item.variables&&item.variables.phone">
              <div class="info-label">电话</div>
              <div class="info-value">{{ item.variables.phone  }}</div>
            </div>
            <!--            <div class="card-info">-->
            <!--              <div class="card-info-item" v-if="item.variables&&item.variables.name">姓名：{{ item.variables.name }}</div>-->
            <!--              <div class="card-info-item" v-if="item.variables&&item.variables.phone">电话：{{item.variables.phone}}</div>-->
            <!--            </div>-->
            <div class="card-info">
              <div class="info-label">申请时间</div>
              <div class="info-value">{{item.created}}</div>
            </div>
            <div class="card-info" v-show="item.endTime">
              <div class="info-label">完成时间</div>
              <div class="info-value">{{item.endTime}}</div>
            </div>
            <div class="divider"></div>
            <div class="card-actions">
              <button class="btn btn-secondary" v-show="item.type!=='3'" @click="showApplicationDetail(item,'info')">任务详情</button>
              <button class="btn btn-primary" v-show="item.type!=='2'&&item.taskId" @click="getActiveItemInfo(item)">去处理</button>
              <!--              <button class="btns btn-primary pd" v-show="!item.variables.siteid&&item.type==='3'&&item.arr_name!=='一般巡检'" @click="getApiDel(item)">删除</button>-->
            </div>
          </div>
        </van-list>
        <!--        <div class="card" >-->
        <!--          <div class="card-title">-->
        <!--            设备维修申请-->
        <!--            <span class="status-tag tag-progress">处理中</span>-->
        <!--          </div>-->
        <!--          <div class="card-info">-->
        <!--            <div class="info-label">申请时间</div>-->
        <!--            <div class="info-value">2025-03-20 14:30</div>-->
        <!--          </div>-->
        <!--          <div class="card-info">-->
        <!--            <div class="info-label">设备类型</div>-->
        <!--            <div class="info-value">福彩销售终端机</div>-->
        <!--          </div>-->
        <!--          <div class="card-info">-->
        <!--            <div class="info-label">新地址</div>-->
        <!--            <div class="info-value">拉萨市城关区XX路123号</div>-->
        <!--          </div>-->
        <!--          <div class="card-info">-->
        <!--            <div class="info-label">完成时间</div>-->
        <!--            <div class="info-value">2025-02-20 15:22</div>-->
        <!--          </div>-->
        <!--          <div class="divider"></div>-->
        <!--          <div class="card-actions">-->
        <!--            <button class="btn btn-primary" @click="showApplicationDetail()">查看详情</button>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>
      <!--      <div id="completedApps" class="tab-content" v-else>-->
      <!--        <div class="card">-->
      <!--          <div class="card-title">-->
      <!--            即开票申请-->
      <!--            <span class="status-tag tag-complete">已完成</span>-->
      <!--          </div>-->
      <!--          <div class="card-info">-->
      <!--            <div class="info-label">申请时间</div>-->
      <!--            <div class="info-value">2025-03-20 11:30</div>-->
      <!--          </div>-->
      <!--          <div class="card-info">-->
      <!--            <div class="info-label">彩票类型</div>-->
      <!--            <div class="info-value">好运十倍 10元 × 3包(300张)</div>-->
      <!--          </div>-->
      <!--          <div class="card-info">-->
      <!--            <div class="info-label">完成时间</div>-->
      <!--            <div class="info-value">2025-03-22 15:30</div>-->
      <!--          </div>-->
      <!--          <div class="divider"></div>-->
      <!--          <div class="card-actions">-->
      <!--            <button class="btn btn-primary" @click="showPage('logistics')">查看物流</button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
//.content{
//  padding-top: 120px;
//  box-sizing: border-box;
//}
/deep/.van-sticky--fixed{
  z-index: 9 !important;
}
</style>